import { fetcher, getHeaders } from './common';

const API_URL = '/api/projects';

export const createIssue = async (data, token, projectId) => {
	const headers = getHeaders(token);
	const url = getUrl(projectId);

	const issue = {
		Title: data.Title,
		Description: data.Description,
		Type: parseInt(data.Type),
		Priority: parseInt(data.Priority),
		Status: parseInt(data.Status),
		StoryPoints: parseInt(data.StoryPoints),
		SprintId: data.SprintId
	};

	try {
		const response = await fetcher(url, 'POST', headers, issue);

		try {
			const dataToReturn = await response.json();
			console.log('dataToReturn',dataToReturn);
			return dataToReturn;
		} catch (error) {
			console.log(error);
		}
	} catch (error) {
		console.log(error);
		return error;
	}
};

export const updateIssue = async (data, token, projectId) => {
	const headers = getHeaders(token);
	const url = getUrl(projectId);
	const { Id, ...issueProps } = data;

	try {
		await fetcher(url + `/${Id}`, 'PUT', headers, issueProps);
	} catch (error) {
		console.log(error);
		return error;
	}
};

export const changeIssueStatus = async (data, token, projectId, id) => {
	const headers = getHeaders(token);
	const url = getUrl(projectId);

	try {
		const response = await fetcher(url + `/${id}`, 'PATCH', headers, data);
		try {
			const dataToReturn = await response.json();
			return dataToReturn;
		} catch (error) {
			console.log(error);
		}
	} catch (error) {
		console.log(error);
		return error;
	}
};

export const deleteIssue = async (id, token, projectId) => {
	const headers = getHeaders(token);
	const url = getUrl(projectId);

	try {
		await fetcher(url + `/${id}`, 'DELETE', headers);
	} catch (error) {
		console.log(error);
		return error;
	}
};

const getUrl = (projectId) => {
	return API_URL + `/${projectId}/issues`;
};
